import { render } from "./FaqQuestion.vue?vue&type=template&id=6ae90a5e&scoped=true"
import script from "./FaqQuestion.vue?vue&type=script&lang=js"
export * from "./FaqQuestion.vue?vue&type=script&lang=js"

import "./FaqQuestion.vue?vue&type=style&index=0&id=6ae90a5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae90a5e"]])

export default __exports__